<div class="" [formGroup]="additionalEducationSubForm">
  <div class="anime-clean contetnheight posrel">
    <div class="row m-b-40">
      <div class="col-md-12 col-xs-12 col-sm-12">
        <div class="header_txt_white">
          <h2>{{ 'EMPLOYMENT_ADDITIONAL_EDUCATION_KNOCKOUT_HEADER' | translate:[firstName, scopeYears] }}</h2>
        </div>
      </div>
    </div>
    <div class="row m-b-40">
      <div class="col-xs-3 col-sm-2 col-md-2 col-lg-1">
        <label class="radio-inline radioLabelTextColor">
          <input type="radio" name="knockoutradio" id="radioYes_{{row}}" value="Yes" (click)="setRadio('Yes')"/>{{ 'LABEL_YES' | translate }}
        </label>
      </div>
      <div class="col-xs-3 col-sm-2 col-md-2 col-lg-1">
        <label class="radio-inline radioLabelTextColor">
          <input type="radio" name="knockoutradio" id="radioNo_{{row}}" value="No" (click)="setRadio('No')"/>{{ 'LABEL_NO' | translate }}
        </label>
      </div>
    </div>
        
    <div class="row fixedbtn">
      <div class="col-xs-12 col-sm-4 col-md-3  fixedbtnb">
        <button type="button" class="btn button font_extrabold" [disabled]="!isKnockoutSelected"
          [class.grow]="isKnockoutSelected" (click)="onNextClick()"> {{'COMMONS_NEXT' | translate }}</button>
      </div>
      <div class="col-xs-12 col-sm-4 col-md-3  fixedbtnb">
        <button type="button" class="btn button_wbg grow font_extrabold" 
          (click)="saveExit()">{{'COMMONS_SAVE_AND_EXIT' | translate }}</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</div>